import React, { Fragment } from 'react';
import styled from 'styled-components';
import Sticky from 'react-stickynode';
import { ThemeProvider } from 'styled-components';
import { saasTheme } from 'common/src/theme/saas';
import { ResetCSS } from 'common/src/assets/css/style';
import { GlobalStyle, ContentWrapper } from '../containers/Saas/saas.style';
import Navbar from '../containers/Saas/Navbar';
import BannerSection from '../containers/Saas/BannerSection';
import FeatureSection from '../containers/Saas/FeatureSection';
import VisitorSection from '../containers/Saas/VisitorSection';
import ServiceSection from '../containers/Saas/ServiceSection';
import FaqSection from '../containers/Saas/FaqSection';
import Footer from '../containers/Saas/Footer';
import PricingSection from '../containers/Saas/PricingSection';
import TrialSection from '../containers/Saas/TrialSection';
import TimelineSection from '../containers/Saas/TimelineSection';
import TestimonialSection from '../containers/Saas/TestimonialSection';
import PartnerSection from '../containers/Saas/PartnerSection';
import { DrawerProvider } from 'common/src/contexts/DrawerContext';
import Image from 'common/src/components/Image';
import SEO from '../components/seo';
import award1 from 'common/src/assets/image/saas/award1.png';
import award2 from 'common/src/assets/image/saas/award2.png';
import a2Observer from 'common/src/assets/image/saas/A2-Observer.png';
import detroitLegal from 'common/src/assets/image/saas/Detroit-Legal.jpg';
import freePress from 'common/src/assets/image/saas/DFP.png';
import mLive from 'common/src/assets/image/saas/Mlive.png';
import soe from 'common/src/assets/image/saas/UofM-SOE.jpg';
import xconomy from 'common/src/assets/image/saas/xconomy.png';

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 400px;
  background: #fafbff;
  flex-direction: column;
  > div {
    width: 90%;
  }
  img {
    width: 200px;
    margin-bottom: 20px;
  }
  section {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
  }
  @media screen and (min-width: 990px) {
    height: 200px;
    flex-direction: row;
    justify-content: center;
    > div {
      width: 40%;
    }
    img {
      margin-bottom: 0;
      margin-right: 40px;
    }
  }
`;

export default () => {
  return (
    <ThemeProvider theme={saasTheme}>
      <Fragment>
        <SEO title="LoanSense" />
        <ResetCSS />
        <GlobalStyle />
        <ContentWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <BannerSection />
          <FeatureSection />
          {/* <ServiceSection /> */}
          <VisitorSection />
          <PricingSection />
          <TestimonialSection />
          {/* <PartnerSection /> */}
          <TimelineSection />
          {/* <FaqSection /> */}
          {/* <TrialSection /> */}
          <div
            style={{
              paddingBottom: '50px',
              paddingTop: '20px',
              backgroundColor: 'rgb(250, 251, 255)'
            }}
          >
            <h2 style={{ textAlign: 'center', color: '#5268db' }}>
              As Seen In
            </h2>
            <FlexContainer>
              <section>
                <Image src={a2Observer} style={{ width: '250px' }} />
              </section>
              <section>
                <Image src={freePress} style={{ width: '250px' }} />
              </section>
              <section>
                <Image src={detroitLegal} style={{ width: '250px' }} />
              </section>
            </FlexContainer>
            <FlexContainer className="square-image">
              <section>
                <Image src={mLive} style={{ width: '150px' }} />
              </section>
              <section>
                <Image src={soe} style={{ width: '150px' }} />
              </section>
              <section>
                <Image src={xconomy} style={{ width: '250px' }} />
              </section>
            </FlexContainer>
          </div>
          <FlexContainer>
            <Image src={award1} />
            <Image src={award2} />
          </FlexContainer>
          <FlexContainer>
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ color: '#2e49ec' }}>Security</h3>
              <p>
                LoanSense uses 256 bit encryption, the standard bank level
                encryption, to protect user data.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ color: '#2e49ec' }}>Privacy</h3>
              <p>
                We do not share employees' personal data with any third parties
                for marketing purposes.
              </p>
            </div>
          </FlexContainer>
          <Footer />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
};
